module.exports = __webpack_public_path__ + "img/vector-quantity.b1118d61.svg";